import React from 'react';
import ReactDOM from 'react-dom';
import './style/login.css';
import './style/dashboard.css';
import './style/matches.css';
import './style/findLove.css';
import './style/eventsDisplay.css';
import './style/activitySwitcher.css'
import './style/userSettings.css'
import './style/animations.css'
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);